import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { MarqueeStrip } from '../components/MarqueeStrip';
import { Bestsellers } from '../components/Bestsellers';
import { ProductLines } from '../components/ProductLines';
import { WhyChamaleon } from '../components/WhyChamaleon';
import { PartnerCTA } from '../components/PartnerCTA';
import { NewsSection } from '../components/NewsSection';
import { ContactForm } from '../components/ContactForm';
import { MobileApp } from '../components/MobileApp';
import { Footer } from '../components/Footer';
type Language = 'ua' | 'en';
export function HomePage() {
  const [language, setLanguage] = useState<Language>('en');
  return <div className="min-h-screen bg-chamaleon-black" data-id="element-323">
      <Header language={language} onLanguageChange={setLanguage} data-id="element-324" />
      <main data-id="element-325">
        <Hero language={language} data-id="element-326" />
        <MarqueeStrip language={language as any} data-id="element-327" />
        <WhyChamaleon language={language} data-id="element-328" />
        <ProductLines language={language} titleOverride="Product Catalog 3" variant="animated" data-id="element-329" />
        <MobileApp language={language} data-id="element-330" />
        <Bestsellers language={language} data-id="element-331" />
        <PartnerCTA language={language} data-id="element-332" />
        <NewsSection language={language} data-id="element-333" />
        <ContactForm language={language} data-id="element-334" />
      </main>
      <Footer language={language} onLanguageChange={setLanguage} data-id="element-335" />
    </div>;
}